export enum CodeType {
  Code = 'Code',
  GeneralCode = 'GeneralCode'
}

export interface UnitCodeFilterDto {
  UnitName?: string;
  Code?: string;
  Email?: string;
  Mobile?: string;
  Grade?: string;
  Term?: string;
  UsageDate?: string;
  CreationDate?: string;
  CodeType?: CodeType;
}

export interface UnitCodeDto {
  Code: string;
  Grade: string;
  UnitName: string;
}

export interface GetUnitCodeDto {
  id: string;
  code: string;
  createdAt: string;
  usageDate?: string;
  unitId: number;
  unitName: string;
  grade: string | null;
  courseName: string;
  studentId?: string | null;
  studentName: string | null;
  studentEmail: string | null;
  studentPhone: string | null;
  courseTerm: string;
  isBurned: boolean;
}

export interface StudentWithUnitCodesDto {
  studentId: string;
  userName: string;
  email: string;
  phoneNumber: string;
  academicYear: string;
  codeId: string;
  code: string;
  usageDate?: string;
  creationDate?: string;
  unitName: string;
  term: string;
}

export interface UnitCodeFilters {
  unitName: string;
  code: string;
  email: string;
  mobile: string;
  grade: string;
  term: string;
  usageDateStart: string;
  usageDateEnd: string;
  creationDateStart: string;
  creationDateEnd: string;
  codeType: string;
  userName?: string;
}

export interface GenerateCodeFormData {
  unitId: string;
  count: string;
}

export interface GenerateGeneralCodeFormData {
  unitId: string;
  code: string;
}

export interface Unit {
  id: number;
  title: string;
  courseId: number;
  courseName: string;
  grade: string;
  term: string;
}

export type SortableFields = keyof GetUnitCodeDto | keyof StudentWithUnitCodesDto;

export interface SortConfig {
  key: SortableFields | null;
  direction: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  totalCount: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
  codes?: T[];
  students?: T[];
}

export interface GeneralCodesResponse {
  GeneralCodes: GetUnitCodeDto[];
  TotalCount: number;
  TotalPages: number;
  CurrentPage: number;
  PageSize: number;
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
}

export const GRADE_OPTIONS = [
  { value: 'Secondary1', label: ' الصف الأول الثانوي' },
  { value: 'Secondary2', label: ' الصف الثاني الثانوي' },
  { value: 'Secondary3', label: ' الصف الثالث الثانوي' },
  { value: 'literary3', label: ' أدبي - الصف الثالث الثانوي' }
];

export const TERM_OPTIONS = [
  { value: 'First', label: 'الفصل الأول' },
  { value: 'Second', label: 'الفصل الثاني' },
  { value: 'FullYear', label: 'السنة كاملة' }
];

export const CODE_TYPE_OPTIONS = [
  { value: CodeType.Code, label: 'أكواد المحاضرات' },
  { value: CodeType.GeneralCode, label: 'الأكواد العامة' }
];

// Course tree types for API response
export interface CourseTreeLesson {
  id: number;
  lessonName: string;
  titel: string;
  order: number;
  active: boolean;
  type: number;
}

export interface CourseTreeUnit {
  id: number;
  unitName: string;
  titel: string;
  active: boolean;
  order: number;
  lessons: CourseTreeLesson[];
}

export interface CourseTreeData {
  id: string;
  courseName: string;
  term: string;
  active: boolean;
  price: number;
  grade: string;
  description: string;
  imagePath: string;
  modificationDate: string;
  units: CourseTreeUnit[];
}

export interface CourseTreeResponse {
  success: boolean;
  message: string | null;
  data: CourseTreeData;
}

// Simple course interface for dropdown
export interface SimpleCourse {
  id: string;
  courseName: string;
  term: string;
  grade: string;
} 